// define app version
const Version = require("../version.json").version

export default Version
